import { Module } from 'vuex-module-decorators';
import store from '@/store';
import FilterModule from '@/store/filter';

@Module({ dynamic: true, store, name: 'conclusionsFilter', namespaced: true })
export default class ConclusionsFilter extends FilterModule {
    constructor(module: ConclusionsFilter) {
        super(module);
    }
}
